export default "__VITE_ASSET__nrMHk4uQ__"